module.exports = __webpack_public_path__ + "static/media/brazil.1c6d3cd9.svg";